export default {
  products: null,
  _product: null,
  homeProducts: null,
  searchConfig: {},
  selectedVariant: null
}
